var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-chevron-right';
                    var viewUrl = 'sprite.svg#view-icon-chevron-right';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?icon-chevron-right#icon-chevron-right';
                            viewUrl = 'sprite.svg?icon-chevron-right#view-icon-chevron-right';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 9.1 16.7',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };